import { Component, Input, EventEmitter, Output, ViewChild } from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";

export class CellActionEvent {
    constructor(action: CellAction, data: any) {
        this.action = action;
        this.data = data;
    }

    public action: CellAction;
    public data: any;
}

export class CellAction {
    constructor(key: string, value: string) {
        this.key = key;
        this.value = value;
    }

    public key: string;
    public value: string;
}

@Component({
    selector: 'datatable-action-cell',
    templateUrl: './datatableActionCell.component.html',
    styleUrls: ['./datatableActionCell.component.css'],
    standalone: false
})
export class DatatableActionCellComponent {
    @Input() public actions: CellAction[];
    @Input() public data: any;
    @Output() public onAction: EventEmitter<CellActionEvent> = new EventEmitter<CellActionEvent>();
    @ViewChild(NgbDropdown) private dropdown: NgbDropdown;

    public raiseOnAction(event: Event, action: CellAction, data: any): void {
        if (event) event.stopPropagation();
        this.dropdown.close();
        this.onAction.emit(new CellActionEvent(action, data));
    }
}